module.exports = __webpack_public_path__ + "img/rever_cycle.2be9c73d.svg";